import React from 'react';
import DefaultIntro, { Content, Icons } from 'components/Intro';
import { withErrorBoundary } from 'components/ErrorBoundary';

function Intro({
  title,
  subtitle,
  description,
  icons,
  certificateIDs,
  size,
  background,
  imgAlt,
  gatsbyImage,
  titleMod,
  handleIconClick,
  scrollerKey,
  button,
  modal,
}) {
  const numberOfIcons = certificateIDs || icons ? certificateIDs?.length || icons?.length : null;

  return (
    <>
      <DefaultIntro
        id="intro"
        background={background}
        imgAlt={imgAlt}
        gatsbyImage={gatsbyImage}
        scrollerKey={scrollerKey}
        size={size}
        Content={
          <Content
            title={title}
            subtitle={subtitle}
            description={description}
            numberOfIcons={numberOfIcons}
            titleMod={titleMod}
            size={size}
            button={button}
            modal={modal}
          />
        }
        Icons={
          certificateIDs || icons ? (
            <Icons certificateIDs={certificateIDs} list={icons} handleIconClick={handleIconClick} />
          ) : null
        }
      />
    </>
  );
}

Intro.displayName = 'Intro';

export default withErrorBoundary(Intro);
